module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-item__quantity"
  }, [(_vm.type) ? [_c('div', {
    staticClass: "cb-item__quantity cb-item__quantity--active"
  }, [(_vm.type == 'range' && _vm.optionsMoreThan10) ? _c('div', {
    staticClass: "cb-item__steper"
  }, [_c('input', {
    ref: "quantity",
    staticClass: "cb-item__control",
    attrs: {
      "type": "number",
      "min": "1",
      "pattern": "[0-9]*",
      "data-cb-id": "item_quantity"
    },
    domProps: {
      "value": _vm.quantity || _vm.meta.min
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.updateQuantityCloseOptions($event.target.value)
      },
      "blur": function($event) {
        _vm.updateQuantity($event.target.value)
      },
      "focus": function($event) {
        _vm.showHelpText = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cb-item__icons"
  }, [_c('div', {
    staticClass: "cb-item__icon",
    class: {
      'cb-item__icon--disabled': _vm.disableIncrement
    },
    on: {
      "click": function($event) {
        _vm.incrementStep()
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "cb-item__icon cb-item__icon--lg",
    class: {
      'cb-item__icon--disabled': _vm.disableDecrement
    },
    on: {
      "click": function($event) {
        _vm.decrementStep()
      }
    }
  }, [_vm._v("-")])])]) : _c('div', {
    staticClass: "cb-item__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.internalQuantity),
      expression: "internalQuantity",
      modifiers: {
        "number": true
      }
    }],
    ref: "select",
    staticClass: "cb-item__control cb-item__control--select",
    class: {
      'cb-item__control--sm': _vm.internalQuantity.toString().length > 2
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.internalQuantity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.qtyOptions), function(qty, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": qty
      }
    }, [_c('span', [_vm._v("Qty " + _vm._s(qty))])])
  }))])])] : [_c('div', {
    ref: "x",
    staticClass: "cb-item__quantity",
    class: {
      'cb-item__quantity--active': _vm.inputMode
    },
    style: (_vm.shadowColor),
    attrs: {
      "tabindex": "0",
      "role": "listbox"
    },
    on: {
      "click": function($event) {
        _vm.toggleInputMode($event)
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.showInputMode($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.showInputMode($event)
      }]
    }
  }, [_c('div', {
    staticClass: "cb-item__placeholder",
    class: {
      'cb-item__placeholder--compress': _vm.quantity && _vm.quantity.length > 3
    }
  }, [((_vm.quantity && _vm.quantity.toString().length < 5) || !_vm.quantity) ? _c('span', [_vm._v("Qty")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.quantity || 1) + "\n      ")]), _vm._v(" "), _c('input', {
    ref: "quantity",
    staticClass: "cb-item__control",
    attrs: {
      "type": "number",
      "min": "1",
      "pattern": "[0-9]*",
      "data-cb-id": "item_quantity"
    },
    domProps: {
      "value": _vm.quantity || 1
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.updateQuantityCloseOptions($event.target.value)
      },
      "blur": function($event) {
        _vm.updateQuantity($event.target.value)
      }
    }
  })])], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale-down-y"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputMode),
      expression: "inputMode"
    }],
    ref: "dropdownContainer",
    staticClass: "cb-item__options",
    class: {
      'cb-item__options--top': _vm.position
    }
  }, _vm._l((_vm.qtyOptions), function(qty) {
    return _c('div', {
      key: qty,
      staticClass: "cb-item__option",
      attrs: {
        "tabindex": "0",
        "role": "listitem"
      },
      on: {
        "keyup": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.updateQuantityCloseOptions(qty)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
          _vm.navigateDown($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
          _vm.navigateUp($event)
        }],
        "click": function($event) {
          _vm.updateQuantity(qty)
        }
      }
    }, [_vm._v("\n        " + _vm._s(qty) + "\n      ")])
  }))]), _vm._v(" "), _c('cb-slide-n-fade', [(_vm.errorMessage) ? _c('div', {
    staticClass: "cb-text__error cb-transitioin__slide"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b15f72f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/Quantity.vue
// module id = 326
// module chunks = 24 34 35 36 37 66